<template>
  <div class="">

    <!-- articles intro -->
    <section class="articles" :class="{ 'articles--en': !isAr }">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col xl="6" lg="12" md="12" class="d-flex align-items-center articles-intro-col"
            :class="isAr ? 'articles-intro-col--rtl' : 'articles-intro-col--ltr'">
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>{{ langDec.landing_blog_title }}</b></h1>
                <p>{{ langDec.articles_page_intro }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!--  -->
    <section class="section93">
      <b-container fluid>
        <b-row class="">
          <b-col xl="12" lg="12" md="12" sm="12">
            <div class="text-section">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.articles_page_featured }}
                  </h2>
                </div>
                <div>
                  <b-row class="">
                    <b-col xl="9" lg="12" md="12" sm="12" class=" contentCol" :class="{ 'order1': isMobileScreen }">
                      <articles id="articles" v-if="refresh" :seeMoreBtn="false" :loadMore="false" :pagination="true" cols="3" title="" info="" :pageSize="12"
                        :descripiton="true" :time="true"></articles>
                    </b-col>
                    <b-col xl="3" lg="12" md="12" sm="12" class="px-4 searchCol" :class="{ 'order2': isMobileScreen }">
                      <div class="pt-3">
                        <b-form-group id="group-admin-edit-interestsType" :label="langDec.articles_filter_type_label"
                          label-for="admin-edit-interestsType">
                          <b-form-select id="admin-edit-interestsType" name="admin-edit-interestsType"
                            @change="loadIntersetsList(form.interestsType)" v-model="form.interestsType"
                             aria-describedby="input-edit-interestsType"
                            label-field="name" id-field="id">
                            <option v-for="s in interestTypessList" :key="s.id" :value="s.interestTypeName">
                              {{ s.interestTypeName }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-group id="group-admin-edit-interests" :label="langDec.articles_filter_interests_label"
                          label-for="admin-edit-interests">
                          <b-form-select id="admin-edit-interests" name="admin-edit-interests"
                            v-model="form.interests"
                            aria-describedby="input-edit-interests" label-field="name" id-field="id">
                            <option v-for="s in intersrtsList" :key="s.interestID" :value="s.interestID">
                              {{ s.interestName }}
                            </option>
                          </b-form-select>
                          <b-form-invalid-feedback id="input-edit-interests">
                            {{ langDec.articles_interest_required }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </b-col>

                    <!--  
                    <b-col xl="9" lg="12" md="12" sm="12" class=" contentCol" :class="{ 'order1': isMobileScreen }">
                      <articles id="articles" v-if="refresh" :seeMoreBtn="false" :loadMore="true" cols="3" title="" info="" :pageSize="8"
                        :descripiton="true" :time="true"></articles>
                    </b-col>
                    -->
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>

        </b-row>
      </b-container>
    </section>


   <!-- subscribe -->
    <section class="subscribe">
      <div>
        <div>
          <div class="">
            <div class="col-md-12 col-sm-12 col-xs-12"
              style="display: flex; align-items: center; justify-content: center; text-align: center;">
              <div class="py-5 my-5">
                <div class="">
                  <h2>{{ langDec.articles_subscribe_title }}</h2>
                  <div class="description">
                    <br>
                    <p v-if="!googleplay && !applestore" style="color: red;">
                      <b>{{ langDec.articles_app_unavailable }}</b>
                      <br>
                      <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                        <span>{{ langDec.articles_contact_us }}</span>
                      </b-button>
                    </p>
                  </div>
                  <div v-if="googleplay || applestore" class="action-btns mt-2">
                    <b-button v-if="applestore" @click="goTowebsite(applestore)" class="px-4 py-3 mx-4 my-3"
                      style="background-color: black; color:white !important; border: black !important;">
                      <div
                        class="store-badge-inner carousel-btn-in-div px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                          <img class="store-badge-inner__apple-img"
                            src="../assets/images/Apple_logo_white.svg.png" alt="">
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div
                        class="store-badge-inner px-3"
                        :class="{ 'store-badge-inner--en': !isAr }"
                      >
                        <div class="store-badge-inner__icon store-badge-inner__icon--google">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div class="carousel-btn-in-div-text store-badge-inner__text subscribe-store-text">
                          <span>{{ langDec.nav_available_on }}</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


  </div>
</template>

<script>
// sendRequest 
import { sendRequest } from "../utils/RequestHelper.js"
import { mapGetters } from "vuex"
import articles from "../components/ArticlesSection.vue"

export default {
  name: 'Home',
  data() {
    return {
      form: {
        interests: null,
        interestsType: null,
      },
      selected: [], // Must be an array reference!
      options: [
        { text: 'Orange', value: 'orange' },
        { text: 'Apple', value: 'apple' },
        { text: 'Pineapple', value: 'pineapple' },
        { text: 'Grape', value: 'grape' }
      ],
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      interestTypessList: [],
      interestTypessListDect: {},
      intersrtsList: [],
      refresh: true,
    }
  },
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {}
    },
    isAr() {
      return this.getlang === "ar"
    },
    isLaptopScreen() {
      // Check if the screen width is greater than or equal to 992px (Bootstrap's lg breakpoint)
      return window.innerWidth >= 992;
    },
    isMobileScreen() {
      // Check if the screen width is less than 992px (Bootstrap's lg breakpoint)
      return window.innerWidth < 992;
    },
  },
  components: {
    articles
  },
  watch: {
    'form.interests': function () {
      this.refresh = false
      this.$router.push({
        query: {
          specializationId: this.form.interests
        },
        hash: '#articles'
      })
    this.$nextTick(() => {
      setTimeout(() => {
        this.refresh = true;
        this.$nextTick(() => {
          const el = document.getElementById('articles');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }, 100);
    });
    }
  },
  methods: {
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToRoute(name, id) {
      this.$router.push({
        name,
        id
      });
    },
    loadIntersetsList(i) {
      this.pageIsLoading = true;
      var successCallback = (response) => {
        this.intersrtsList = response.data.data
        this.pageIsLoading = false
      };
      var errorCallback = (error) => {
        if (error?.response?.status == 404) {
          this.$router.push({
            name: "home",
          });
        }
        this.pageIsLoading = false;
        this.alertType = "danger";
        this.alertText = this.langDec["errorMessage"];
        this.alertCountdown = process.env.VUE_APP_ALERT_COUNTDOWN;
      };
      sendRequest(
        "get",
        "Interests/type/" + this.interestTypessListDect[this.form.interestsType] + "/",
        true,
        null,
        successCallback,
        errorCallback
      );
    },
    loadIntersetTypesList() {
      this.pageIsLoading = true;
      this.interestTypessListDect = {}
      var successCallback = (response) => {
        this.interestTypessList = response.data.data
        this.interestTypessList.forEach(element => {
          this.interestTypessListDect[element.interestTypeName] = element.interestTypeId
        })
      };
      var errorCallback = (error) => {
        if (error?.response?.status == 404) {
          this.$router.push({
            name: "home",
          });
        }
        this.pageIsLoading = false;
        this.alertType = "danger";
        this.alertText = this.langDec["errorMessage"];
        this.alertCountdown = process.env.VUE_APP_ALERT_COUNTDOWN;
      };
      sendRequest(
        "get",
        "InterestType/",
        true,
        null,
        successCallback,
        errorCallback
      );
    },
  },
  created() {
    this.loadIntersetTypesList();

  }
}
</script>

<style scoped>
.articles .intro-section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/images/articlesBG.png);
  background-size: cover;
  background-position: right center;
  width: auto;
  height: 450px !important;
  color: white;
}

.articles--en .intro-section {
  background-position: left center;
}

.articles-intro-col--rtl {
  text-align: right;
  margin-inline-start: auto;
}

.articles-intro-col--ltr {
  text-align: left;
  margin-inline-end: auto;
}

.articles .text-section {
  align-items: center;
  margin-inline-start: 70px;
}

.articles .text-section h2 {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}

.articles .text-section p {
  font-size: 24px;
}




/* greyBox */
.greyBox {
  padding: 50px 40px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px 30px;
  font-size: 20px;
  width: 100%;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.greyBox .text-section .pref {
  font-size: 16px;
  color: #858585;
}


/* subscribe */
.subscribe {
  background-color: #f5f5f5;
}


/* section93 */
.section93 {
  padding: 40px 40px;
}

.section93 .itemBox {
  border: 1px solid #36A9E1;
  padding: 15px;
  border-radius: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.filterChBox .btn-group-toggle {
  display: block;
}

.order2 {
  order: 1;
}

.order1 {
  order: 2;
}

@media (max-width: 991.98px) {

  .greyBox,
  .section93 {
    padding: 50px 30px;
  }

  .intro-section {
    height: 550px !important;
  }

  .text-section h2 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .button-section .btn {
    font-size: 10px !important;
  }

  .greyBox .text-section {
    padding: 10px;
  }
}

@media (max-width: 767.98px) {

  .greyBox,
  .section93 {
    padding: 40px 10px;
  }

  .intro-section {
    height: 350px !important;
  }

  .articles .text-section {
    margin-inline-start: 30px;
  }
}

/* App store badges — EN: text | icon */
.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.subscribe-store-text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}
</style>